<h2>{{ title }}</h2>
<p *ngIf="description">{{ description }}</p>
<ng-content></ng-content>
